// extracted by mini-css-extract-plugin
export var hidden = "_4s-1";
export var leftPanel = "_4s-2";
export var readonlyInspector = "_4s-3";
export var rightPanel = "_4s-0";